import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'

import { WHITE, TRANSLUCENT, NONE, NONE_WITH_BORDERS } from './widget-background-type'

var BackgroundOption = BootslideMenu.WidgetMultipleChoiceOption.extend({
	property: 'background',
	updateModel: function (value) {
		this.options.widgetUpdater.applyUpdate(widget => {
			widget.setBackground(value)
		}, { types: [ 'shape', 'speedometer', 'text', 'chart-table', 'old-chart',
				'notes', 'report', 'perspective', 'linear-gauge', 'initiative-chart',
				'initiative-timeline', 'dataset-table', 'dataset-value', 'dataset-filter',
				'embedded-content', 'chart', 'chart-color-legend'] })
	}
})

function createMenu (model) {
	let currentBackground = model.get('background')
	let options = _([ WHITE, TRANSLUCENT, NONE, NONE_WITH_BORDERS ])
		.filter(type => {
			if (type === NONE_WITH_BORDERS) {
				// #30125 Only show the None With Borders option if it's already
				// selected (ie don't let them turn it on)
				return currentBackground === type
			} else {
				return true
			}
		})
		.map(type => {
			return {
				label: type,
				contentView: BackgroundOption.extend({
					value: type,
					label: i18n.get('dashboards.background.' + _.camelCase(type))
				}),
				model: model
			}
		})
		.value()

	return {
		id: 'background',
		type: 'submenu',
		label: 'dashboards.background',
		target: options
	}
}

export default createMenu
export const Option = BackgroundOption

createMenu.__filename__ = 'dashboards/widgets/wob-background-menu.js'
